/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_SubmittingInputs */

const en_common_support_submitting = /** @type {(inputs: Common_Support_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

const zh_common_support_submitting = /** @type {(inputs: Common_Support_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交中…`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Common_Support_SubmittingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_submitting = /** @type {((inputs?: Common_Support_SubmittingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_SubmittingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_submitting(inputs)
	return zh_common_support_submitting(inputs)
});
export { common_support_submitting as "common.support.submitting" }